import { render, staticRenderFns } from "./PwdResetForm.vue?vue&type=template&id=45b0dd4b&"
import script from "./PwdResetForm.vue?vue&type=script&lang=ts&"
export * from "./PwdResetForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports